import { elemLabel, NoAccess } from "./noAccess";
import { useMyContext } from "../components/myContext";

export const WithRoles = ({ can, children, then, otherwise, fail = null }) => {
  const { acp } = useMyContext();
  then = then || children;

  if (acp.hasRoles(can)) {
    return then;
  } else {
    const label = elemLabel(children, "WithRoles");
    return (
      otherwise || (
        <>
          {fail}
          <NoAccess label={label} can={can} />
        </>
      )
    );
  }
};
